import type { RequestOptions } from "@mittwald/api-client-commons";
import type { AxiosInstance } from "axios";
import {
  buildMemoryStorage,
  setupCache,
  type CacheRequestConfig,
} from "axios-cache-interceptor";
import { minimatch } from "minimatch";
const axiosCacheStorage = buildMemoryStorage();

export const setup = (instance: AxiosInstance) => {
  setupCache(instance, {
    generateKey: (options) => {
      const { url = "/", params } = options;
      const searchString =
        params instanceof URLSearchParams ? "?" + params.toString() : "";
      return url + searchString;
    },
    storage: axiosCacheStorage,
  });
};

export const invalidatePath = async (path: string) => {
  const promises = Object.keys(axiosCacheStorage.data).map(
    async (cachedPath) => {
      const [cachedPathWithoutSearchParams] = cachedPath.split("?");
      if (
        cachedPathWithoutSearchParams &&
        minimatch(cachedPathWithoutSearchParams, path)
      ) {
        await axiosCacheStorage.remove(cachedPath);
      }
    },
  );

  return Promise.all(promises);
};

export const withUncachedConfig = (
  options: RequestOptions = {},
): RequestOptions => ({
  ...options,
  onBeforeRequest: (req) => {
    const config = req.requestConfig as CacheRequestConfig;
    config.cache = false;
  },
});
